import {
  PIPELINE_COMPARISONS,
  PIPELINE_SPAN_LABELS,
  PIPELINE_SPANS,
  type PipelineComparison,
  type PipelineSpan,
} from '@lib/enums/pipeline-span.enum'
import { SegmentedControl, type SegmentedOption } from '@/components/ui/segmented-control'

const SPAN_OPTIONS: readonly SegmentedOption<PipelineSpan>[] = PIPELINE_SPANS.map((value) => ({ value, label: PIPELINE_SPAN_LABELS[value] }))

const COMPARE_OPTIONS: readonly SegmentedOption<PipelineComparison>[] = PIPELINE_COMPARISONS.map((value) => ({
  value,
  label: value === 'last_year' ? 'Last year' : 'Weeks before',
}))

interface SpanControlsProps {
  span: PipelineSpan
  compare: PipelineComparison
  onSpan: (span: PipelineSpan) => void
  onCompare: (compare: PipelineComparison) => void
}

/**
 * How many weeks a Pipeline page shows and what they're set against
 * (docs/pipeline-view.spec.md, "Spans"): whole two-week periods, compared with
 * the same weeks last year or the weeks just before.
 */
export function SpanControls({ span, compare, onSpan, onCompare }: SpanControlsProps) {
  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-2">
      <SegmentedControl label="Weeks shown" size="sm" value={span} options={SPAN_OPTIONS} onValueChange={onSpan} />
      <span className="flex items-center gap-2">
        <span aria-hidden="true" className="text-small text-ink-muted">
          against
        </span>
        <SegmentedControl label="Compared with" size="sm" value={compare} options={COMPARE_OPTIONS} onValueChange={onCompare} />
      </span>
    </div>
  )
}
